module.exports = "/images/ico-klarna.svg?9d56da15f2078e8c84c70d2c9fd24a6e";